import React from "react";

interface ContractIconProps {
  size?: number | string;
  color?: string;
  className?: string;
  onClick?: () => void;
}

const ContractIcon: React.FC<ContractIconProps> = ({ size = 20, color = '#292D32', className, onClick }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
  >
    <path d="M11 4V9H16" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9 16V11H4" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M17.5 2.5L11.25 8.75" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8.75 11.25L2.5 17.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
); export default ContractIcon;